import React from 'react';
export const ProductIntroSection = () => {
  const bullets = ['Complete system organized by level and health condition', 'Activities for older adults + guidance for caregivers', 'Printable health trackers to share with healthcare providers', "Adapted for Alzheimer's, Parkinson's, Diabetes and High Blood Pressure"];
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-180">
      <div className="max-w-5xl mx-auto text-center w-[92%] md:w-full" data-id="element-181">
        <div className="inline-block bg-familia-cyan text-familia-bg font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider" data-id="element-182">
          📚 A Complete At-Home Senior Wellness and Care System
        </div>
        <h2 className="text-4xl sm:text-6xl md:text-7xl font-display font-bold mb-2" data-id="element-183">
          VITALITY 360™
        </h2>

        <p className="text-familia-gray text-[15px] md:text-xl max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-184">
          5 Core Modules + VIP Exercise Module + 3 Exclusive Bonuses —{' '}
          <span className="text-white font-bold" data-id="element-185">
            Cognitive engagement for older adults.
          </span>{' '}
          <span className="text-familia-gold font-bold" data-id="element-186">
            Practical organization for caregivers. Greater peace of mind for the
            entire family.
          </span>
        </p>
        <div className="bg-familia-card border border-familia-cyan/15 p-6 md:p-12 rounded-3xl mb-10 md:mb-16" data-id="element-187">
          <p className="text-familia-gray text-[15px] md:text-lg mb-8 md:mb-12 leading-relaxed" data-id="element-188">
            · 5 complete modules · VIP Module with 150+ exercises · 3 bonuses ·
            Sharp Mind Workbook · Move with Confidence · Expert Care Protocol ·
            Vitality 360 Health Tracker · The Empowered Caregiver Guide · Vital
            Nutrition 60+ · Family Connection Kit · Safe Home Checklist ·
            Level-based activities throughout.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-3xl mx-auto" data-id="element-189">
            {bullets.map((b, i) => <div key={i} className="flex items-center gap-3" data-id="element-190">
                <span className="text-familia-green text-xl" data-id="element-191">✅</span>
                <span className="font-bold text-[15px] sm:text-base" data-id="element-192">{b}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};